import React from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { useTheme } from '@veneer/theme';

type RadioButtonsStyles = {
  root: SerializedStyles;
  vertical: SerializedStyles;
  legend: { base: SerializedStyles; disabled: SerializedStyles };
};

const useStyles = (): RadioButtonsStyles => {
  const theme = useTheme();

  return React.useMemo(() => {
    return {
      root: css({
        display: 'inline-flex',
        gap: theme.orbitalFive,
      }),
      vertical: css({
        flexDirection: 'column',
        gap: theme.orbitalThree,
      }),
      legend: {
        base: css({
          color: theme.color.foreground.medium,
          marginBottom: theme.orbitalThree,
          ...theme.typography.labelRegular,
        }),
        disabled: css({
          color: theme.color.foreground.disabled,
        }),
      },
    };
  }, [theme]);
};

export default useStyles;
